export const PUSH_PERMISSION_MODEL_DATA = 'push_permission_model_data';
